import Lightning from '@lightningjs/sdk/src/Lightning';
import { Colors, Router, Storage, Utils } from '@lightningjs/sdk';
import { Column, Input, Row } from '@lightningjs/ui-components';
//getPersonalizedMoviesSearch
import { getSearchCatalog } from '../../api/movies';
//KeyboardConfig
import { keyboardConfig } from './keyboardConfig';
//Components
import VODComponent from '../MyList/components/VODComponent';
//AuthRoute
import AuthRoute from '../../components/layouts/AuthRoute/AuthRoute';
import { checkImage } from '../../utils/helpers';
import PaidTitleModal from '../Home/components/UpgradeModal';
import Keyboard from '../../components/Keyboard/components/Keyboard';
let movies;

export default class Search extends AuthRoute {
  static _template() {
    return {
      ...super._template(),
      PaidTitleModal: {
        zIndex: 200,
        w: 1920,
        h: 1080,
        rect: true,
        color: Colors('#000000').get(),
        type: PaidTitleModal,
        visible: false,
      },
      w: 1920,
      h: 1080,
      LogoIcon: {
        w: 606,
        h: 274,
        Shadow: {
          y: 806,
          x: 1314,
          rect: true,
          texture: Lightning.Tools.getSvgTexture(Utils.asset('images/logo-shadow.png'), 606, 274),
          zIndex: 99,
        },
        Logo: {
          y: 978,
          x: 1555,
          texture: Lightning.Tools.getSvgTexture(Utils.asset('images/logo.png'), 341, 53),
          zIndex: 100,
        },
      },
      Content: {
        Labels: {
          Icon: {
            y: 90,
            x: 715,
            zIndex: 10,
            texture: Lightning.Tools.getSvgTexture(Utils.asset(`/images/search.svg`), 42, 32),
            color: Colors('#676767').get(),
          },
          InputContainer: {
            collision: true,
            rect: true,
            x: 695,
            y: 80,
            w: 695,
            h: 54,
            color: Colors('#d6d6d6').get(),
            shader: { type: Lightning.shaders.RoundedRectangle, radius: 15 },
            InputField: {
              w: 695,
              h: 54,
              Input: {
                type: Input,
                w: 650,
                h: 54,
                x: 45,
                listening: false,
                style: {
                  backgroundColor: Colors('#D6D6D6').alpha(1).get(),
                  textStyle: {
                    textColor: Colors('#444444').alpha(1).get(),
                    fontSize: 36,
                    fontFace: 'OpenSans-Regular',
                  },
                  cursorStyle: {
                    textColor: Colors('#444444').alpha(1).get(),
                  },
                },
              },
            },
          },
          Placeholder: {
            w: 695,
            h: 67,
            x: 770,
            y: 83,
            text: { text: 'Search', fontSize: 36 },
            color: Colors('#444444').get(),
          },
        },
      },
      Keyboard: {
        type: Keyboard,
        x: 75,
        y: 189,
        w: 1920,
        rect: true,
        color: Colors('#000000').alpha(0).get(),
        flex: { direction: 'column', justifyContent: 'center', alignItems: 'center' },
        limit: 45,
      },
      Wrapper: {
        x: 200,
        y: 430,
        h: 650,
        w: 1720,
        clipping: true,
        Column: {
          collision: true,
          x: 25,
          y: 40,
          itemSpacing: 30,
          type: Column,
          plinko: true,
        },
      },
      ResultText: {
        y: 380,
        x: 215,
        text: {
          text: 'Explore',
          fontSize: 36,
          fontFace: 'OpenSans-SemiBold',
        },
        color: Colors('#FAFAFA').get(),
      },
    };
  }

  _enable() {
    this._InputField.tag('Input').value = '';
    this._changePlaceholder();
    this._Column.patch({
      x: 25,
    });
  }

  _changePlaceholder() {
    const isInputEmpty = this._InputField.tag('Input').value === '';
    this.tag('Placeholder').patch({
      visible: isInputEmpty,
    });
    this._onInputChanged();
  }

  get _InputField() {
    return this.tag('InputField');
  }

  set collections(val) {
    this._collections = val;
  }

  $hidePaidTitleModal() {
    this.tag('PaidTitleModal').visible = false;
    this._setState('Column');
  }

  _onInputChanged() {
    let input = this._InputField.tag('Input').value;
    if (input.length === 0 && !this._searchCollectionCalled) {
      this._clearSearchTimeout();
      this._searchCollection();
      this._searchCollectionCalled = true; // Set the flag to true
    } else if (input.length > 2) {
      this._startSearchTimeout();
      this._searchCollectionCalled = false; // Reset the flag if input is not empty
    }
  }
  _startSearchTimeout() {
    this._clearSearchTimeout();
    //after 600 ms fire _doSearch
    this._searchTimeout = setTimeout(() => {
      this._doSearch();
    }, 600);
  }
  _searchCollection() {
    const ROW_SIZE = 4;
    const collections = this._collections;
    const rows = [];
    for (let i = 0, j = Object.keys(collections).length; i < j; i += ROW_SIZE) {
      rows.push({ coll: Object.values(collections).slice(i, i + ROW_SIZE) });
    }
    const items = rows.map((row, rowIndex) => ({
      type: Row,
      collision: true,
      style: { itemSpacing: 30 },
      h: 250,
      items: row.coll.map((collection, index) => {
        return {
          collision: true,
          type: VODComponent,
          src: collection['screenshot.expiring_url'],
          h: 222,
          w: 393,
          collection: collection,
          title: collection.name,
          index,
          rowIndex,
          data: {
            id: collection.id,
            kind: collection.kind,
          },
        };
      }),
    }));
    this._Column.items = items;
    this.tag('ResultText').patch({
      text: 'Explore',
    });
    this._Column.patch({
      x: 25,
    });
  }
  async _doSearch() {
    let input = this._InputField.tag('Input').value;
    try {
      const ROW_SIZE = 7;
      const { data: row } = await getSearchCatalog(input);
      const rows = [];
      if (row.length > 0) {
        for (let i = 0, j = row.length; i < j; i += ROW_SIZE) {
          rows.push({ items: row.slice(i, i + ROW_SIZE) });
        }

        const items = rows.map((row, rowIndex) => ({
          type: Row,
          h: 320,
          collision: true,
          items: row.items.map((item, index) => ({
            collision: true,
            type: VODComponent,
            rowIndex,
            index,
            collection: item,
            isLocked: item.tvod ?? false,
            isProtected: item?.locked ?? false,
            src: checkImage(
              item?.alternative_covers,
              item?.['cover_art.expiring_url'] ?? 'default_image.png'
            ),
            // src: item['cover_art.expiring_url'],
            w: 204,
            h: 290,
            title: item.name ?? '',
            data: {
              originalImage: item?.['cover_art.expiring_url'] ?? 'default_image.png',
              id: item?.id ?? 'Unknown',
              kind: item?.kind ?? 'Unknown',
            },
          })),
        }));
        let input = this._InputField.tag('Input').value;
        if (input.length !== 0) {
          this._Column.items = items;
          this.tag('ResultText').patch({
            text: 'Search Results',
          });
          this._Column.patch({
            x: 60,
          });
        }
      } else {
        this.tag('ResultText').patch({
          text: 'No results found',
        });
        this._Column.patch({
          x: 50,
        });
        this._Column.items = [];
      }
      this._searchCollectionCalled = false;
    } catch (e) {
      this._Column.items = [];
      this.tag('ResultText').patch({
        text: 'No results found',
      });
    }
  }
  _clearSearchTimeout() {
    if (this._searchTimeout) {
      clearTimeout(this._searchTimeout);
    }
  }
  get id() {
    return 'SearchPage';
  }

  _active() {
    const inputField = this.tag('Input');
    // this.tag('Keyboard').inputField(inputField);
    movies = this._movies;
    super._active();
    this.tag('Input').color = Colors('#D6D6D6').get();
  }
  _firstActive() {
    //when active for the first time focus keyboard
    this._setState('Column');
  }
  get _Column() {
    return this.tag('Wrapper.Column');
  }
  get _Keyboard() {
    return this.tag('Keyboard');
  }
  set movies(val) {
    return (this._movies = val);
  }
  _handleLeft() {
    if (!Router.isNavigating()) {
      Router.focusWidget('sidebar');
    }
  }

  $unselectCurrentIndex() {
    let currentIndex = this._Column.selectedIndex;
    let rowIndex = (this._Column.items[currentIndex].selectedIndex = undefined);
  }

  $setFocus({ rowIndex, index }) {
    this._setState('Column');
    let modifiedIndex = index % 7;
    // this._Column.selectedIndex = rowIndex;
    this._Column.scrollTo(rowIndex, 400);
    this._Column.items[rowIndex].selectedIndex = modifiedIndex;
  }

  $scroll(event) {
    this._handleScroll(event);
  }

  _handleScroll = this._debounce((event) => {
    let currentIndex = this._Column.selectedIndex;
    let nextIndex = currentIndex + 1;
    let previousIndex = currentIndex - 1;

    if (event.deltaY > 0) {
      this._Column.scrollTo(nextIndex, 50);
    } else if (event.deltaY < 0) {
      this._Column.scrollTo(previousIndex, 50);
    }
  }, 200);

  _debounce(func, delay) {
    let debounced = (...args) => {
      if (debounced.timeout) {
        clearTimeout(debounced.timeout);
      }
      debounced.timeout = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
    return debounced;
  }

  $setState(state) {
    this._setState(state);
  }

  $handleEnter() {
    let fp = this.application.focusPath;
    let isProtected = (fp && fp.length > 0 && fp[fp.length - 1])._isProtected;
    let activeTile = fp[fp.length - 1].data || {};
    switch (activeTile.kind) {
      case 'collection':
        this.navigate(`categories/${activeTile.id}`);
        break;
      case 'movie':
        if (isProtected) {
          this.tag('PaidTitleModal').visible = true;
          this._setState('PaidTitleModal');
        } else {
          Storage.set('video', { id: activeTile.id, watchList: 0 });
          Router.navigate(`movie/${activeTile.id}`);
        }
        break;
      case 'subseries':
        this.navigate(`series/${activeTile.id}`);
        break;
    }
  }
  static _states() {
    return [
      class PaidTitleModal extends this {
        _getFocused() {
          return this.tag('PaidTitleModal');
        }
      },
      class Keyboard extends this {
        _getFocused() {
          this._InputField.tag('Input').listening = true;
          return this.tag('Keyboard');
        }
        _handleDown() {
          this._setState('Column');
          this._InputField.tag('Input').listening = false;
        }
      },
      class Column extends this {
        _getFocused() {
          this._InputField.tag('Input').listening = false;
          return this.tag('Column');
        }

        _handleUp() {
          this._setState('Keyboard');
          this._InputField.tag('Input').listening = true;
        }
      },
    ];
  }
}
